// extracted by css-extract-rspack-plugin
export default {"root":"gU7aEI_MgEnSbZHo","linkOpen":"EKrsa2iMNzYeJWXC","linkClosed":"V2MOA8JLEOTPGF4S","logoFull":"XwUfbalaa0UHDLBb","logoIcon":"S6UizKpXxxIiOBxs"};